/* eslint-disable object-curly-newline */

export default {
	status: 200,
	data: {
		code: 200,
		media: {
			created_at: '2019-06-19 21:01:41',
			height: '79',
			id: 65491,
			name: 'cute dog',
			ratio: null,
			size: 10024,
			thumbnail: 'https://www.washingtonpost.com/resizer/LC0UahHNg_1BPgG35QyiUNKDqvc=/1023x0/smart/arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/HB4AT3D3IMI6TMPTWIZ74WAR54.jpg',
			type: 'image',
			url: 'https://www.washingtonpost.com/resizer/LC0UahHNg_1BPgG35QyiUNKDqvc=/1023x0/smart/arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/HB4AT3D3IMI6TMPTWIZ74WAR54.jpg',
			width: '1166',
		},
	},
};
